import axios from 'axios'

export default {
    loadUser() {
        return axios.get('/load-user')
    },
    loadStat() {
        return axios.get('/load-user-stat')
    },
    loadVirtualBalance() {
        return axios.get('/load-virtual-balance')
    },
    updateUserData(field, value) {
        return axios.post('/user-profile/update', {field: field, value: value})
    },
    refreshUnreadChats() {
        return axios.get('/load-unread-chats')
    },
    refreshToken() {
        return axios.get('/refresh-token')
    },
    loadUserPowerUps() {
        return axios.get('/web-api/load-user-power-ups')
    }
}
